import { Link } from 'react-router-dom';
import { BloggerPost } from '../services/mockData';
import { ChevronRight } from 'lucide-react';

interface WidgetPostListProps {
  title: string;
  posts: BloggerPost[];
  loading: boolean;
}

export function WidgetPostList({ title, posts, loading }: WidgetPostListProps) {
  if (loading) {
    return (
      <div className="flex flex-col h-full w-full">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold font-bengali text-[#111111] dark:text-white flex items-center">
            <span className="w-1 h-5 bg-[#D32F2F] rounded-full mr-2"></span>
            {title}
          </h2>
        </div>
        <div className="bg-[#F9F9F9] dark:bg-gray-800/80 rounded border border-[#E5E5E5] dark:border-gray-800 flex-1 flex items-center justify-center p-4">
          <span className="text-gray-500 font-bengali text-sm animate-pulse">লোড হচ্ছে...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold font-bengali text-[#111111] dark:text-white flex items-center">
          <span className="w-1 h-5 bg-[#D32F2F] rounded-full mr-2"></span>
          {title}
        </h2>
        <Link 
          to={`/category/${encodeURIComponent(title)}`}
          className="text-[#D32F2F] text-sm font-bold font-bengali hover:text-red-700 active:scale-95 transition-transform"
          aria-label={`${title} এর আরও খবর`}
        >
          আরও
        </Link>
      </div>
      <div className="bg-[#F9F9F9] dark:bg-gray-800/80 rounded border border-[#E5E5E5] dark:border-gray-800 flex flex-col flex-1 pb-0">
        {posts.length > 0 ? (
          <ul className="space-y-0 w-full pl-2.5 pr-2.5 pt-2.5 pb-2.5">
            {posts.map(post => (
              <li key={post.id} className="flex items-start border-b border-gray-200 dark:border-gray-700 pt-0 pb-0 mb-2.5 last:border-0 last:pb-0 last:mb-0 group">
                <ChevronRight className="w-3.5 h-3.5 text-[#D32F2F] mr-1.5 mt-[3px] shrink-0 opacity-80 group-hover:opacity-100 transition-opacity" />
                <Link to={post.url ? new URL(post.url).pathname : `/post/${post.id}`} className="text-[#333333] dark:text-gray-300 text-[13px] font-semibold font-bengali hover:text-[#D32F2F] dark:hover:text-[#D32F2F] leading-snug">
                  {post.title}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <div className="flex items-center justify-center flex-1 h-full py-6">
            <span className="text-gray-500 font-bengali text-sm">কোন খবর পাওয়া যায়নি</span>
          </div>
        )}
      </div>
    </div>
  );
}
